export default "<app-show-notices></app-show-notices>\n";